export const data = {
    home: {
        title: 'Home',
        url: '/',
        image: 'placeholder.png'
    },
    about: {
        title: 'About',
        url: '/about',
        image: 'placeholder.png'
    },
    capabilities: {
        title: 'Capabilities',
        url: '/capabilities',
        image: 'placeholder.png'
    },
    portfolio: {
        title: 'Portfolio',
        url: '/portfolio',
        image: 'placeholder.png'
    },
    insights: {
        title: 'Insights',
        url: '/insights',
        image: 'placeholder.png'
    },
    careers: {
        title: 'Careers',
        url: '/careers',
        image: ''
    },
    contact: {
        title: 'Contact',
        url: '/contact',
        image: ''
    },
    openSource: {
        title: 'Open Source',
        url: '/open-source',
        image: ''
    },
    press: {
        title: 'Press',
        url: '/press',
        image: 'placeholder.png'
    },
    partners: {
        title: 'Partners',
        url: '/partners',
        image: 'placeholder.png'
    },
    platforms: {
        title: 'Platforms',
        url: '/platforms',
        image: 'placeholder.png'
    },
};
